import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8000";
//export const baseURL = "https://motorcare-backend.metropolitano.tech";
//export const baseURL = "https://suzuki-backend.metropolitano.tech";
//export const baseURL = "https://gwm-backend.metropolitano.tech";
//export const baseURL = "https://mhl-backend.metropolitano.tech";
//export const baseURL = "https://caetano-backend.metropolitano.tech";
//export const baseURL = "https://ronil-backend.metropolitano.tech";
//export const baseURL = "https://mozam-backend.metropolitano.tech";
export const baseURL = "https://conceionarias-backend.metropolitano.tech"


const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
